export default __webpack_public_path__ + "static/media/big_head.55cc9fe6.svg";